<template>
  <aside class="aside aside-fixed">
    <div class="aside-header">
      <a href="/" class="aside-logo">har<span>Vest</span></a>
      <a href="" class="aside-menu-link">
        <i data-feather="menu"></i>
        <i data-feather="x"></i>
      </a>
    </div>
    <div class="aside-body">
      <div class="aside-loggedin">
        <div class="d-flex align-items-center justify-content-start">
          <a href="" class="avatar"><img src="https://ca.slack-edge.com/EHTHJQWQ2-WLK2ENRQV-db5dc6d265f4-512" class="rounded-circle" alt=""></a>
          <div class="aside-alert-link">
            <a href="" class="new" data-bs-toggle="tooltip" title="You have 2 unread messages"><i data-feather="message-square"></i></a>
            <a href="" class="new" data-bs-toggle="tooltip" title="You have 4 new notifications"><i data-feather="bell"></i></a>
            <a href="" v-on:click="logout" data-bs-toggle="tooltip" title="Sign out"><i data-feather="log-out"></i></a>
          </div>
        </div>
        <div class="aside-loggedin-user">
          <a href="#loggedinMenu" class="d-flex align-items-center justify-content-between mg-b-2" data-bs-toggle="collapse">
            <h6 class="tx-semibold mg-b-0">Abayomi Mosaku</h6>
            <i data-feather="chevron-down"></i>
          </a>
          <p class="tx-color-03 tx-12 mg-b-0">Senior Product Engineer ...</p>
        </div>
        <div class="collapse" id="loggedinMenu">
          <ul class="nav nav-aside mg-b-0">
            <li class="nav-item"><a href="" class="nav-link"><i data-feather="edit"></i> <span>Edit Profile</span></a></li>
            <li class="nav-item"><a href="" class="nav-link"><i data-feather="user"></i> <span>View Profile</span></a></li>
            <li class="nav-item"><a href="" class="nav-link"><i data-feather="settings"></i> <span>Account Settings</span></a></li>
            <li class="nav-item"><a href="" class="nav-link"><i data-feather="help-circle"></i> <span>Help Center</span></a></li>
            <li class="nav-item"><a href="" v-on:click="logout" class="nav-link"><i data-feather="log-out"></i> <span>Sign Out</span></a></li>
          </ul>
        </div>
      </div><!-- aside-loggedin -->

      <ul class="nav nav-aside">


        <li class="nav-label">Spiritual</li>
        <li class="nav-item"></li>
        <li class="nav-item"><a href="" class="nav-link"><i data-feather="monitor"></i> <span>Service Groups</span> </a></li>
        <li class="nav-item" :class="{active: $route.path === '/watch'}">
          <a href="/watch" class="nav-link"><i data-feather="clock"></i> <span>Watch</span> </a>
        </li>
        <li class="nav-item"><a href="" class="nav-link"><i data-feather="star"></i> <span>Prayer</span> </a></li>
        <li class="nav-item"><a href="" class="nav-link"><i data-feather="file"></i> <span>Books</span></a></li>
        <li class="nav-item"><a href="" class="nav-link"><i data-feather="slash"></i> <span>Events</span></a></li>
        <li class="nav-item"><a href="" class="nav-link"><i data-feather="star"></i> <span>Kingdom Care</span> </a></li>
        <li class="nav-item"><a href="" class="nav-link"><i data-feather="trash"></i> <span>Trash</span></a></li>


        <li class="nav-label mg-t-25">Mental / Career</li>
        <li class="nav-item" :class="{active: $route.path === '/feed-2'}">
          <a href="/feed-2" class="nav-link"><i data-feather="gift"></i> <span>Opportunities</span></a>
        </li>
        <li class="nav-item" :class="{active: $route.path === '/'}">
          <a href="" class="nav-link"><i data-feather="briefcase"></i> <span>Jobs</span></a>
        </li>
        <li class="nav-item" :class="{active: $route.path === '/'}">
          <a href="" class="nav-link"><i data-feather="book-open"></i> <span>Learning</span></a>
        </li>
        <li class="nav-item" :class="{active: $route.path === '/'}">
          <a href="" class="nav-link"><i data-feather="message-square"></i> <span>Messaging</span></a>
        </li>
        <li class="nav-item" :class="{active: $route.path === '/'}">
          <a href="" class="nav-link"><i data-feather="share-2"></i> <span>Networks</span></a>
        </li>
        <li class="nav-item" :class="{active: $route.path === '/'}">
          <a href="" class="nav-link"><i data-feather="bell"></i> <span>Notifications</span></a>
        </li>




        <li class="nav-label mg-t-25">Physical Development</li>
        <li class="nav-item"><a href="" class="nav-link"><i data-feather="menu"></i> <span>Nutrition</span></a></li>
        <li class="nav-item"><a href="" class="nav-link"><i data-feather="activity"></i> <span>Self Mgt</span></a></li>
        <li class="nav-item"><a href="" class="nav-link"><i data-feather="sun"></i> <span>Exercise</span></a></li>
      </ul>
    </div>
  </aside>
</template>

<script>

export default {
  name: "SideBarAsideUser",
  methods:{
    logout(){
      localStorage.clear();
      this.$router.push({name: 'Login'});
    }
  },
}
</script>

